import RealTimeLogsView from './RealTimeLogsView';
import SamplingPageView from './SamplingPageView';
import SamplingEventView from './SamplingEventView';
import SamplingManagementView from './SamplingManagementView';
import TraceParamsView from './TraceParamsView';
import EventAnalysisView from './EventAnalysisView';
import EventAnalysisTemplateView from './EventAnalysisTemplateView';
import FunnelAnalysisView from './FunnelAnalysisView';
import FunnelEditView from './FunnelEditView';
import FunnelDataView from './FunnelDataView';
import TraceTutorial from './TraceTutorial'
import auth from '../Service/AuthFetchService';

import { BrowserRouter as Router, Link, Route, Redirect } from 'react-router-dom';
import React from 'react';
import { Layout, Menu, Button } from 'antd';
import { MenuOutlined, FieldTimeOutlined, AppstoreFilled, ClockCircleOutlined, ControlOutlined, ShareAltOutlined } from '@ant-design/icons';

class RealTimeView extends React.Component {

    pathToView = {
        '/real_time/logs_test': 'LogsTest',
        '/real_time/logs_prod': 'LogsProd',
        '/real_time/form_trend': 'TrendFormView',
        '/real_time/sampling': 'SamplingManagementView',
        '/real_time/sampling/pages': 'SamplingManagementView',
        '/real_time/trace_params': 'TraceParamsView',
        '/real_time/event_analysis': 'EventAnalysisView',
        '/real_time/funnel_analysis': 'FunnelAnalysisView',
        '/real_time/trace_params/tutorial': 'TraceTutorial'
    }

    constructor() {
        super();
        const path = window.location.pathname;
        const view = this.pathToView[path];
        //console.log(view);
        this.state = {
            collapsed: false,
            currentView: view === undefined ? 'TrendFormView' : view
        };
    }

    collapseSider() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    render() {
        return (
            <Router basename="/real_time">
                <Layout className="site-layout-background" style={{ padding: '24px 0 0' }} hidden={this.props.hidden} >
                    <Layout.Sider className="site-layout-background" width={200} theme={"light"} collapsed={this.state.collapsed}>
                        <Menu
                            mode="inline"
                            defaultSelectedKeys={[this.state.currentView]}
                            defaultOpenKeys={['Form', 'Logs', 'Sampling']}
                            selectedKeys={[this.state.currentView]}
                            onSelect={(item) => this.setState({ currentView: item.key })}
                            style={{ height: '100%' }}
                        >
                            <Button size="middle" icon={<MenuOutlined />} onClick={() => this.collapseSider()}
                                style={{
                                    color: "#000000",
                                    border: "none",
                                    margin: "0px 0px 0px 15px"
                                }}
                            />
                            {auth.prefix('datap:real_time:sampling:') && <Menu.SubMenu icon={<ControlOutlined />} key="Sampling" title="埋点管理">
                                <Menu.Item key="SamplingManagementView">
                                    <Link to="/sampling">埋点配置</Link>
                                </Menu.Item>
                                <Menu.Item key="TraceParamsView">
                                    <Link to="/trace_params">追踪参数</Link>
                                </Menu.Item>
                            </Menu.SubMenu>}
                            
                            {auth.prefix('datap:real_time:logs:') && <Menu.SubMenu icon={<ClockCircleOutlined />} key="Logs" title="埋点日志">
                                <Menu.Item key="LogsTest">
                                    <Link to="/logs_test">测试</Link>
                                </Menu.Item>
                                <Menu.Item key="LogsProd">
                                    <Link to="/logs_prod">线上</Link>
                                </Menu.Item>
                            </Menu.SubMenu>}
                            <Menu.SubMenu icon={<AppstoreFilled />} key="Form" title="流量分析">
                                {/* {auth.allow('datap:real_time:form:trend') && <Menu.Item key="TrendFormView">
                                    <Link to="/form_trend">数据概览</Link>
                                </Menu.Item>} */}
                                <Menu.Item key="EventAnalysisView">
                                    <Link to="/event_analysis">事件分析</Link>
                                </Menu.Item>
                                <Menu.Item key="FunnelAnalysisView">
                                    <Link to="/funnel_analysis">漏斗分析</Link>
                                </Menu.Item>
                            </Menu.SubMenu>
                        </Menu>
                    </Layout.Sider>
                    <Layout.Content justify="space-around" align="middle" style={{ padding: '0 0 0 0', minHeight: 280  }}>
                        {auth.allow('datap:real_time:logs:view') && <Route path="/logs_test" exact component={RealTimeLogsView} />}
                        {auth.allow('datap:real_time:logs:view') && <Route path="/logs_prod" exact component={RealTimeLogsView} />}
                        {/* {auth.allow('datap:real_time:form:trend') && <Route path="/form_trend" exact render={() => <QuickBIView pageName="整体趋势" />} />} */}
                        {auth.allow('datap:real_time:sampling:manage') && <Route path="/sampling" exact component={SamplingManagementView} />}
                        {auth.allow('datap:real_time:sampling:manage') && <Route
                            path="/sampling/edit/:id"
                            exact
                            render={history => <SamplingEventView defId={history.match.params.id} />} />}
                        {auth.allow('datap:real_time:sampling:manage') && <Route path="/sampling/new" exact component={SamplingEventView} />}
                        {auth.allow('datap:real_time:sampling:manage') && <Route path="/sampling/pages" exact component={SamplingPageView} />}
                        <Route path="/trace_params" exact component={TraceParamsView} />
                        <Route path="/event_analysis" exact component={EventAnalysisView} />
                        <Route path="/event_analysis/template/:id" exact  
                            render={history => <EventAnalysisTemplateView templateId={history.match.params.id} />} />
                        <Route path="/funnel_analysis" exact component={FunnelAnalysisView} />
                        <Route path="/funnel_analysis/new" exact component={FunnelEditView} />
                        <Route path="/funnel_analysis/edit/:id" exact 
                            render={history => <FunnelEditView funnelId={history.match.params.id} />} />
                        <Route path="/funnel_analysis/data/:id" exact 
                            render={history => <FunnelDataView funnelId={history.match.params.id} />} />
                        <Route path="/" exact render={() => <Redirect to="/sampling" />} />
                        <Route path="/trace_params/tutorial" exact component={TraceTutorial} />
                    </Layout.Content>
                </Layout>
            </Router>
        );
    }
}


export default RealTimeView;